<template>
  <!-- <v-container> -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <!-- <v-card-title>
            各協會經費核結統計
          </v-card-title> -->
          <v-card-subtitle>
            <v-row class="py-2 mt-2">
              <v-col cols="3">
                <!-- {{selectedYear}} -->
                <v-select :items="years" label="年度" 
                item-title="rocYear"
                item-value="adYear"
                v-model="selectedYear"></v-select>
              </v-col>
              <v-col cols="3">
                <v-select :items="events" label="計畫" 
                item-title="projectTitle"
                item-value="projectId"
                v-model="selectedEvent"></v-select>
              </v-col>
              <v-col cols="3">
                <v-select :items="statuses" label="是否結案" 
                item-title="label"
                item-value="value"
                clearable
                v-model="selectedStatus"></v-select>
              </v-col>
              <v-col cols="3" class="d-flex justify-end">
                <v-btn color="primary" @click="exportFile" :loading="buttonStatus.buttonLoading">
                  下載
                  <v-tooltip activator="parent">
                  下載{{(selectedYear??new Date().getFullYear())-1911}}年 各協會經費核結統計
                  </v-tooltip>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-data-table :headers="headers" :items="items" class="" :loading="loadingTable" no-data-text="尚無資料">
            <template v-slot:item.id="{ item , index }">
              {{index+1}}
            </template>
            <template v-slot:item.deptName="{ item }">
              {{item.deptName}}<br>
              {{item.deptNo}}
            </template>
            <template v-slot:item.trainAmount="{ item }">
              {{Number(item.trainAmount).toLocaleString()}}
            </template>
            <template v-slot:item.equipmentAmount="{ item }">
              {{Number(item.equipmentAmount).toLocaleString()}}
            </template>
            <template v-slot:item.annualAmount="{ item }">
              {{Number(item.annualAmount).toLocaleString()}}
            </template>
            <template v-slot:item.totalAmount="{ item }">
              {{Number(item.totalAmount).toLocaleString()}}
            </template>
            <template v-slot:item.closedTrainAmount="{ item }">
              {{Number(item.closedTrainAmount).toLocaleString()}}
            </template>
            <template v-slot:item.closedEquipmentAmount="{ item }">
              {{Number(item.closedEquipmentAmount).toLocaleString()}}
            </template>
            <template v-slot:item.closedAnnualAmount="{ item }">
              {{Number(item.closedAnnualAmount).toLocaleString()}}
            </template>
            <template v-slot:item.closedTotalAmount="{ item }">
              {{Number(item.closedTotalAmount).toLocaleString()}}
            </template>
            <template v-slot:item.diffTotalAmount="{ item }">
              {{Number(item.diffTotalAmount).toLocaleString()}}
            </template>
            <template v-slot:item.percentClosed="{ item }">
              {{Number(item.percentClosed).toLocaleString()}}%
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  <!-- </v-container> -->
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue"
definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'ASSOCIATIONBUDGETEXPENSE', //系統代碼(系統授權設定中的系統代碼)
  },
})

const events=reactive( [
  { projectTitle:'黃金計畫' , value:'Y' , projectId:'Y'},
])
const statuses=reactive( [
  { label:'已結案' , value:'Y'},
  { label:'未結案' , value:'N'},
])

const fileUrl = useStorage("drFsUrl").value;
const loadingTable = ref(false)
const selectedYear=ref(new Date().getFullYear().toString())
const selectedEvent=ref('Y')
const selectedStatus=ref(null)
const items=reactive([])

const headers = computed(() => [
  { title: '#', value: 'id' },
  { title: '協會', value: 'deptName' },
  { 
    title: '預算',
    align: 'center' as const,
    children: [
      { title: '移訓、參賽核定數', value: 'trainAmount',align: 'end' as const },
      { title: '器材核定數', value: 'equipmentAmount',align: 'end' as const },
      { title: selectedEvent.value === 'Y' ? '運動型保險核定數' : '年度核定數', value: 'annualAmount',align: 'end' as const },
      { title: '核定數合計', value: 'totalAmount',align: 'end' as const },
    ],
  },
  { 
    title: '核銷',
    align: 'center' as const,
    children: [
      { title: '移訓核結數', value: 'closedTrainAmount' ,align: 'end' as const},
      { title: '器材核結數', value: 'closedEquipmentAmount' ,align: 'end' as const},
      { title: selectedEvent.value === 'Y' ? '運動型保險核結數' : '年度核結數', value: 'closedAnnualAmount' ,align: 'end' as const},
      { title: '總核結數', value: 'closedTotalAmount',align: 'end' as const },
    ],
  },
  { title: '總核定未核結數', value: 'diffTotalAmount' ,align: 'end' as const},
  { title: '核結率', value: 'percentClosed',align: 'end' as const }
])

const buttonStatus = reactive({
    buttonLoading: false
  });

const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}

// API
const { data: yearList, execute: fetchFilterYearList } = await useApi<any>(createUrl('/tca/expenserequestprojectlist/getYear', {
}))
const years = computed(() => yearList ? yearList.value.data : []);

const getAssociationBudgetExpense = async() =>{
  loadingTable.value=true
  if(isEmpty(selectedYear.value) || isEmpty(selectedEvent.value)){
    $popSwal('error','請選擇年度或計畫','請選擇年度或計畫')
    loadingTable.value=false
    return
  }
  console.log(selectedEvent.value)
  let projectid = '';
  let isGold = 'Y';
  //如果selectedEvent.value不是'Y'
  if(selectedEvent.value !== 'Y'){
    projectid = selectedEvent.value;
    isGold = 'N';
  } else {
    projectid = '';
    isGold = 'Y';
  }
  let api='/tca/associationbudgetexpense/getListByProjectId'
  let query={
    belongYear: selectedYear.value,
    projectId: projectid,
    isGold: isGold,
    closedType: selectedStatus.value,
  }
  try {
    const response = await $api(api, {
      method: 'POST',
      query,
    });
    if (response && response.data && response.data.length > 0) {
      items.splice(0, items.length, ...response.data);
    } else {
      items.splice(0, items.length);
      console.error('Fetch error: no data getAssociationBudgetExpense');
    }
    loadingTable.value=false
  } catch (error) {
    items.splice(0, items.length);
    console.error('Error getAssociationBudgetExpense:', error);
    loadingTable.value=false
  }
}

const getProject = async() =>{
  loadingTable.value=true
  if(isEmpty(selectedYear.value)){
    $popSwal('error','請選擇年度','請選擇年度')
    loadingTable.value=false
    return
  }
  try{
    const response = await $api('/tca/expenserequestprojectlist/getProject', {
      method: 'GET',
      query: {
        year: selectedYear.value,
      },
    });
    if (response && response.data && response.data.length > 0) {
      events.splice(1, events.length, ...response.data);
    } else {
      events.splice(1, events.length);
      console.error('Fetch error: no data getAssociationBudgetExpense');
    }
  }catch(error){
    console.error('Error getProject:', error);
    events.splice(1, events.length)
  }finally{
    loadingTable.value=false
  }
}
getProject()


const exportFile= async () => {
  buttonStatus.buttonLoading = true;
  if(isEmpty(selectedYear.value) || isEmpty(selectedEvent.value)){
    $popSwal('error','請選擇年度或計畫','請選擇年度或計畫')
    buttonStatus.buttonLoading = false
    return
  }
  let projectid = '';
  let isGold = 'Y';
  //如果selectedEvent.value不是'Y'
  if(selectedEvent.value !== 'Y'){
    projectid = selectedEvent.value;
    isGold = 'N';
  } else {
    projectid = '';
    isGold = 'Y';
  }
  let apiUrl='/tca/associationbudgetexpense/exportByProjectId'
  try {
    await $api(apiUrl, {
      method: 'GET',
      query:{
        belongYear:selectedYear.value??new Date().getFullYear(),
        projectId:projectid,
        isGold:isGold,
      }
    }).then(async(response) => {
      if(!response?.data?.fileId){
        throw new Error('File ID is undefined');
      }
      const url = await mapFileDownload(fileUrl, response.data.fileId)
      // const url = await mapFileDownload(useStorage("drFsUrl", "").value, response.data.fileId)
      window.open(url,'_blank');
    });
    // buttonStatus.buttonLoading = false;
  } catch (error) {
    popSwal('error','下載失敗',error)
    buttonStatus.buttonLoading = false;
  }
};

onMounted(()=>{
  getAssociationBudgetExpense()
})

watch([selectedYear,selectedEvent,selectedStatus],()=>{
  getAssociationBudgetExpense()
})

watch(selectedYear,()=>{
  selectedEvent.value='Y'
  getProject()
})

</script>

<style scoped>
.v-data-table {
  font-size: 14px;
}
.v-data-table :deep() tr:nth-child(1) th:nth-child(4) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}
.v-data-table :deep() tr:nth-child(2) th:nth-child(5) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}
.v-data-table :deep() tr:nth-child(1) th:nth-child(5) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}
.v-data-table :deep() tr:nth-child(1) th:nth-child(6) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}
.v-data-table :deep() tr td:nth-child(7) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}
.v-data-table :deep() th:nth-child(10) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}
.v-data-table :deep() th:nth-child(11) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}
.v-data-table :deep() tr td:nth-child(11) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}
.v-data-table :deep() tr td:nth-child(12) {
  border-left: 1px solid rgba(47, 43, 61, 0.1);
}

</style>
